export const getCountryCodeFromLanguageCode = (languageCode: string): string => {
  if (languageCode?.indexOf('-') === -1) {
    return languageCode?.toLowerCase();
  }

  return languageCode?.split('-')?.[1]?.toLowerCase();
};
